module.exports = __webpack_public_path__ + "static/media/config_data.6cff2cfc.svg";